import {
  Button,
  Modal,
  SingleSelectDropdown,
} from "@monsterindia/global-ui-components";
import React from "react";

import BlockedCompaniesList from "./BlockedCompaniesList";

const BlockCompanyMobileModal: React.FC<BlockCompanyModalProps> = ({
  showModal,
  handleModal,
  args,
  handleDropdownSelect,
  onChangeHandler,
  blockCompanyList,
  unblockCompanyHandler,
  isMobile,
}) => {
  return (
    <Modal
      screenAlignment="bottom-sheet"
      showModal={showModal}
      closeModal={handleModal}
      showCloseButton={true}
      showHandleBar={true}
      customClass="!px-0 !py-2"
    >
      <>
        <div className="px-3 py-2 text-base font-bold">Block Companies</div>
        <div className="bg-border-moderate h-[1px] w-full"></div>
        <div className="h-[75vh] p-4">
          <SingleSelectDropdown
            {...args}
            handleDropdownSelect={handleDropdownSelect}
            onChangeHandler={onChangeHandler}
          />
          <BlockedCompaniesList
            isMobile={isMobile}
            blockCompanyList={blockCompanyList}
            unblockCompanyHandler={unblockCompanyHandler}
          />
        </div>
        <div className="modalFooterFix modal_footer flex justify-around gap-5">
          <Button
            onClick={handleModal}
            label="Cancel"
            modifier="tertiary"
            className="w-full md:w-auto"
          />
          <Button
            onClick={handleModal}
            label="Done"
            modifier="primary"
            size="lg"
            className="w-full px-10 md:w-auto"
          />
        </div>
      </>
    </Modal>
  );
};

export default BlockCompanyMobileModal;
